import React from "react"
import { useTranslations } from "next-intl"

import { ReducedProductData } from "@/lib/storefront/product/product"
import { cn } from "@/lib/utils"
import { calculateAvailabilityData } from "@/components/ui/helpers/product-availability-helper"

export function ProductCardDeliveryInfo(props: {
  productData: ReducedProductData | undefined
  isoLocale: string
  compact: boolean | undefined
  isListView?: boolean
}) {
  const t = useTranslations("storefront")

  const availabilityData = calculateAvailabilityData(props.isoLocale, props.productData, /*props.standardVariant,*/ t)
  const availabilityText = availabilityData.availabilityText
    ? availabilityData.availabilityText
    : t("product.fast_shipping")

  return (
    <>
      <div className={cn("flex items-center justify-start gap-2 text-balance", { "gap-1": props.compact })}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={"/img/delivery.svg"}
          className={cn("aspect-square h-8 object-contain lg:h-6 xl:h-8", {
            "@xl:aspect-[unset]! @xl:h-6!": props.isListView,
            "h-4!": props.compact,
          })}
          alt={""}
        />
        <div className={"flex flex-col items-start justify-center"}>
          {props.productData?.availability === true ? (
            <p className={"text-xs/tight lg:text-[0.65em] xl:text-xs"}>{availabilityText}</p>
          ) : (
            <p className={"text-xs/tight lg:text-[0.65em] xl:text-xs"}>{t("product.delivery_time_unknown")}</p>
          )}
        </div>
      </div>
      {props.isListView && (
        <div
          className={cn("hidden items-center justify-start gap-2 text-balance @2xl:flex", { "gap-1": props.compact })}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img className={cn("h-6")} alt={""} src={"/img/delivery_free.svg"} />
          <div className={"flex flex-col items-start justify-center"}>
            <p className={"text-xs/tight lg:text-[0.65em] xl:text-xs"}>{t("product.free_shipping")}</p>
          </div>
        </div>
      )}
    </>
  )
}
